import React from "react";
import { SvgIcon } from "@mui/material";

const OverviewIcon = ({
    width = "19",
    height = "19",
    viewBox = "0 0 19 19",
    fill = "#D3D3D3",
    isSelected = false,
    ...props
}) => (
    <SvgIcon
        component="svg"
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox={viewBox}
        fill="none"
        sx={{ display: "block" }}
        {...props}
    >
        <g clipPath="url(#clip0_1161_23704)">
            <path
                d="M4.05566 16.945V9.57992L9.76473 3.44238L15.4738 9.57992V16.945C15.4738 17.2705 15.3535 17.5827 15.1394 17.8129C14.9252 18.0431 14.6348 18.1725 14.332 18.1725H5.19748C4.89465 18.1725 4.60423 18.0431 4.39009 17.8129C4.17596 17.5827 4.05566 17.2705 4.05566 16.945Z"
                fill={isSelected ? "#BBC5FF" : fill}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.95754 2.57424C9.17166 2.34412 9.46203 2.21484 9.7648 2.21484C10.0676 2.21484 10.3579 2.34412 10.5721 2.57424L17.4229 9.93928C17.6309 10.1708 17.746 10.4809 17.7434 10.8027C17.7408 11.1246 17.6207 11.4324 17.409 11.66C17.1973 11.8876 16.911 12.0167 16.6116 12.0195C16.3122 12.0223 16.0238 11.8986 15.8084 11.675L9.7648 5.17778L3.72118 11.675C3.50583 11.8986 3.21741 12.0223 2.91803 12.0195C2.61865 12.0167 2.33226 11.8876 2.12056 11.66C1.90886 11.4324 1.78878 11.1246 1.78618 10.8027C1.78357 10.4809 1.89866 10.1708 2.10665 9.93928L8.95754 2.57424Z"
                fill={isSelected ? "#4D44D8" : "#989898"}
            />
        </g>
        <defs>
            <clipPath id="clip0_1161_23704">
                <rect width="17" height="17" fill="white" transform="translate(1 1)" />
            </clipPath>
        </defs>
    </SvgIcon>
);

export default OverviewIcon;
